import styled from "styled-components";
import { breakpoints } from "styles";
import { Container } from "styles/common/container";
import Image from "next/image";

export const InfoCardWrapper = styled.section<{
  backgroundColor: string;
  $isCompact?: boolean;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: ${({ $isCompact }) =>
    $isCompact ? "80px 100px 0px 100px" : "80px 100px 40px 100px"};
  gap: 16px;
  background-color: ${({ backgroundColor }) => backgroundColor};
  @media ${breakpoints.mobile} {
    padding: ${({ $isCompact }) =>
      $isCompact ? "60px 20px 0px 20px" : "60px 20px 20px 20px"};
    gap: 12px;
  }
`;

export const InfoContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media ${breakpoints.mobile} {
    padding: 0;
  }
`;

export const InfoCardHeading = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  @media ${breakpoints.mobile} {
    width: 100%;
    height: 46px;
    gap: 8px;
  }
`;

export const TickWrapper = styled.div`
  padding-top: 5px;
  @media ${breakpoints.mobile} {
    padding-top: 4px;
  }
`;

export const InfoCardTitle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 750px;
  line-height: 46px;
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.primary};
  font-size: ${({ theme }) => theme.fontSizes["4xl"]};
  font-weight: 700;
  @media ${breakpoints.mobile} {
    width: 300px;
    padding: 40px 0 0 0;
    line-height: 28px;
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
    text-align: center;
  }
`;

export const InfoCardSubtitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  @media ${breakpoints.mobile} {
    width: 100%;
    margin: 10px 0 70px 0;
    text-wrap: pretty;
    text-align: center;
    line-height: 20px;
    font-size: ${({ theme }) => theme.fontSizes["sm"]};
    color: ${({ theme }) => theme.colors.neutral[700]};
  }
`;

export const InfoCardInfoWrapper = styled.div<{ $isCompact?: boolean }>`
  display: grid;
  align-items: space-around;
  justify-content: center;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  padding: ${({ $isCompact }) =>
    $isCompact ? "56px 56px 11px 56px" : "56px 56px 56px 56px"};
  width: fit-content;
  height: fit-content;
  @media ${breakpoints.mobile} {
    grid-template-columns: 1fr;
    width: 100%;
    height: auto;
    padding: 16px;
    gap: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 40px;
  }
`;

export const InfoCardContainer = styled.div<{ padding: string }>`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 528px;
  height: fit-content;
  min-height: fit-content;
  border-radius: 12px;
  padding: 25px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 4px 24px rgba(135, 206, 250, 0.5);
  @media ${breakpoints.mobile} {
    width: 90%;
    max-width: 480px;
    height: auto;
    padding: 12px;
  }
`;

export const InfoBold = styled.b`
  display: flex;
  flex-direction: row;
  gap: 8px;
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  white-space: normal;

  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes["md"]};
  }
`;

export const InfoBoldNumber = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["5xl"]};
  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
    padding-left: 8px;
  }
`;

export const InfoBoldText = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["2hxl"]};
  color: ${({ theme }) => theme.colors.neutral[1000]};
  line-height: 40px;
  @media ${breakpoints.mobile} {
    line-height: 24px;
    font-size: ${({ theme }) => theme.fontSizes["lg"]};
  }
`;

export const InfoBulletin = styled.div`
  gap: 16px;
`;

export const InfoNormal = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  color: ${({ theme }) => theme.colors.neutral[1000]};
  line-height: 1.5;
  width: 440px;
  white-space: normal;
  margin-top: 8px;
  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes["md"]};
    width: 100%;
  }
`;
export const ImageContainer1 = styled(Image)`
  width: 32px;
  height: 32px;
  margin-right: 8px;
  align-self: center;
  margin-bottom: 20px;
`;
export const ImageContainer2 = styled(Image)`
  width: 32px;
  height: 32px;
  margin-right: 8px;
  margin-bottom: 30px;
  margin-top: 10px;
`;
